export const Button = {
  baseStyle: {
    fontWeight: 'medium',
  },
  sizes: {
    sm: {
      fontSize: '12px',
      padding: '16px',
    },
    md: {
      fontSize: '16px',
      padding: '24px',
    },
  },
  variants: {
    outline: {
      border: '2px solid',
      borderColor: 'primary',
    },
    solid: {
      bg: 'primary',
      color: 'white',
      '&:focus': {
        outline: '4px solid',
        outlineColor: 'primary',
        backgroundColor: 'accentPrimary',
        outlineOffset: 0,
        boxShadow: 'none',
      },
      '&:hover': {
        boxShadow: '0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)',
        backgroundColor: 'primary',
      },
      '&:disabled': {
        backgroundColor: 'gray.100',
        color: 'gray.400',
      },
    },
    ghost: {
      '&:hover': {
        backgroundColor: 'transparent',
      },
      '&:focus': {
        outline: 'none',
        boxShadow: 'none',
      },
      '&:disabled': {
        color: 'gray.400',
      },
    },
    red: {
      bg: 'red.500',
      color: 'white',
      '&:focus': {
        backgroundColor: 'red.500',
        outlineOffset: 0,
        boxShadow: 'none',
      },
      '&:hover': {
        boxShadow: '0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)',
        backgroundColor: '#ce3a3a',
      },
      '&:disabled': {
        backgroundColor: 'gray.100',
        color: 'gray.400',
      },
    },
  },
  defaultProps: {
    size: 'md',
    variant: 'outline',
  },
}
